import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ErrorBoundary } from './app/ErrorBoundary';
import { setupTelegram } from './telegram/telegram';
import './index.css';

/**
 * Точка входа.
 *
 * `setupTelegram()` вызывается ДО первой отрисовки: он публикует переменные `--tg-theme-*`,
 * на которых построена палитра (ТЗ §14.3). Сделай мы это в эффекте — первый кадр вышел бы
 * в цветах по умолчанию, и у клиента со светлой темой экран мигнул бы тёмным.
 */
const telegram = setupTelegram();

/**
 * Тап по пустому месту убирает клавиатуру.
 *
 * В Mini App экран и так в половину телефона, а поднятая клавиатура съедает ещё половину:
 * вписав название организации, владелец не мог доскроллить до выбора отрасли — приходилось
 * мотать щель в несколько строк. Телефон сам клавиатуру не прячет: в вебе её закрывает
 * только `blur`, а тап по неинтерактивному div фокус не снимает.
 *
 * Слушатель один на документ, а не обработчик на каждом экране: поле ввода есть почти в
 * каждой форме кабинета, и двадцать копий разошлись бы в первый же новый экран.
 *
 * ПО ИНТЕРАКТИВНЫМ ЭЛЕМЕНТАМ НЕ СНИМАЕМ НАМЕРЕННО. Снятие фокуса закрывает клавиатуру,
 * страница тут же вырастает в высоту — и `click`, который приходит после `pointerdown`,
 * попадает уже в другой элемент. То есть тап по «Сохранить» нажимал бы что-то соседнее.
 */
document.addEventListener('pointerdown', (event) => {
  const focused = document.activeElement;
  if (!(focused instanceof HTMLInputElement || focused instanceof HTMLTextAreaElement)) return;
  const target = event.target;
  if (target instanceof Element && target.closest('input, textarea, select, button, a, label, [role="button"]')) {
    return;
  }
  focused.blur();
});

const container = document.getElementById('root');
// Не создаём контейнер сами: его отсутствие означает сломанный index.html, и молчаливое
// «сделаем div» спрятало бы поломку сборки.
if (!container) throw new Error('В документе нет элемента #root');

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      <App telegram={telegram} />
    </ErrorBoundary>
  </StrictMode>,
);
